/** Muted footer: legal links + a note on signature legal effect and retention. */
export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__links">
        <a href="#" className="footer__link">
          用户协议
        </a>
        <span className="footer__sep">·</span>
        <a href="#" className="footer__link">
          隐私政策
        </a>
      </div>
      <p className="footer__note">
        您在本页面所作的电子签名经确认后具有法律效力，视为您对上述内容的认可。签名数据将被安全存储并按相关规定留存，仅用于本次确认事项。
      </p>
    </footer>
  );
}
